let tdePrintAssets;
function tdeAssetDeadline(promise,ms=10000){
 let timer;
 return Promise.race([promise,new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error('Artwork loading timed out')),ms)})]).finally(()=>clearTimeout(timer));
}
function loadTdePrintAssets(root){
 const load=()=>tdeAssetDeadline(Promise.all([
  document.fonts.load('700 120px "TDE Print Serif"'),
  document.fonts.load('400 47px DM'),
  ...['serif','sans'].map(face=>fetch(root.dataset[face+'Metrics'],{signal:AbortSignal.timeout(10000)}).then(r=>{if(!r.ok)throw Error('Artwork metrics unavailable');return r.json()}))
 ])).then(([serif,sans,serifMetrics,sansMetrics])=>{
  if(!serif.length||!sans.length)throw Error('Artwork font unavailable');
  return {serif:serifMetrics,sans:sansMetrics};
 });
 if(!tdePrintAssets)tdePrintAssets=load().catch(()=>load()).catch(error=>{tdePrintAssets=undefined;throw error});
 return tdePrintAssets;
}
function initDoorstep(scope=document){
document.documentElement.classList.add('tde-js');
scope.querySelectorAll('[data-theme-toggle]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';button.addEventListener('click',()=>{const dark=document.documentElement.dataset.theme!=='dark';document.documentElement.dataset.theme=dark?'dark':'light';button.setAttribute('aria-pressed',String(dark));button.setAttribute('aria-label',dark?'Switch to light appearance':'Switch to dark appearance')})});
scope.querySelectorAll('[data-open]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';button.addEventListener('click',()=>{const d=document.getElementById(button.dataset.open);if(!d)return;d.querySelectorAll('[data-personaliser]').forEach(setupPersonaliser);d.showModal()})});
scope.querySelectorAll('dialog').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='1';dialog.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}})});
scope.querySelectorAll('.collection').forEach(collection=>{collection.querySelectorAll('[data-filter]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';button.addEventListener('click',()=>{collection.querySelectorAll('[data-filter]').forEach(b=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button))});let n=0;collection.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;if(!card.hidden)n++});collection.querySelector('[data-filter-status]').textContent=`Showing ${n} designs.`})})});
scope.querySelectorAll('[data-personaliser]').forEach(root=>{
 if(root.dataset.ready||root.closest('dialog'))return;
 const go=()=>setupPersonaliser(root);
 root.addEventListener('pointerdown',go,{once:true});
 root.addEventListener('focusin',go,{once:true});
 if('requestIdleCallback' in window)requestIdleCallback(go,{timeout:1500});else setTimeout(go,300);
});
}
function setupPersonaliser(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 const canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d'),texture=new Image();
 const form=root.querySelector('form'),check=root.querySelector('input[type=checkbox]'),add=root.querySelector('[data-add]');
 const select=root.querySelector('[data-variant]'),sizeButtons=root.querySelector('[data-size-buttons]'),sizeSelect=root.querySelector('[data-size-select]');
 const alertBox=root.querySelector('[data-layout-alert]'),alertText=root.querySelector('[data-layout-alert-text]'),tryLarger=root.querySelector('[data-try-larger]');
 const recheck=root.querySelector('[data-recheck]'),sticky=root.querySelector('[data-sticky]'),priceEl=root.querySelector('span[data-price]');
 let fontsReady=false,assetError=false,metrics,layoutMessage='',layoutKind='',physicalHeight=400,submitting=false,largerOption=null;
 loadTdePrintAssets(root).then(data=>{metrics=data;fontsReady=true;render()}).catch(()=>{assetError=true;render()});
 texture.crossOrigin='anonymous';texture.src=root.dataset.texture;texture.onload=render;
 function flag(message,kind){if(!layoutMessage){layoutMessage=message;layoutKind=kind}}
 function values(){return Object.fromEntries([...root.querySelectorAll('[data-key]')].map(input=>[input.dataset.key,(input.value.trim()||(input.required?input.placeholder:'')||'').toUpperCase()]))}
 function text(str,x,y,size,maxWidth,serif=false,spacing=0){
  if(!str)return;
  const face=metrics[serif?'serif':'sans'],chars=Array.from(str);
  const glyphs=chars.map(c=>face.glyphs[c.codePointAt(0)]);
  if(glyphs.some(g=>!g)){flag('This wording contains a character we can’t print automatically. Please use different wording or contact us before ordering.','wording');return}
  let k=size/face.units;
  const width=glyphs.reduce((n,g)=>n+g[0]*k,0)+Math.max(chars.length-1,0)*spacing;
  const ratio=width?Math.min(1,maxWidth/width):1;
  k*=ratio;spacing*=ratio;
  const ink=glyphs.filter(g=>g[1]).map(g=>g[1]);
  if(!ink.length){flag('Please enter printable wording.','wording');return}
  const top=Math.max(...ink.map(b=>b[3]))*k,bottom=Math.min(...ink.map(b=>b[1]))*k;
  const baseline=y+(top+bottom)/2;
  let pos=x-width*ratio/2;
  ctx.font=`${serif?'700':'400'} ${size*ratio}px ${serif?'"TDE Print Serif"':'DM'}`;
  ctx.fontKerning='none';ctx.textAlign='left';ctx.textBaseline='alphabetic';
  const bounds=[];
  chars.forEach((c,i)=>{
   const g=glyphs[i],b=g[1];
   if(b){ctx.fillText(c,pos,baseline);bounds.push([pos+b[0]*k,baseline-b[3]*k,pos+b[2]*k,baseline-b[1]*k])}
   pos+=g[0]*k+spacing;
  });
  const scale=physicalHeight/800,physicalWidth=canvas.width*scale;
  if((top-bottom)*scale<9)flag('This wording is too long to print clearly at this size. Shorten it or choose a larger mat.','size');
  if(bounds.some(b=>b[0]*scale<20||b[1]*scale<20||b[2]*scale>physicalWidth-20||b[3]*scale>physicalHeight-20))flag('This wording needs more space around the edge. Shorten it or choose a larger mat.','size');
 }
 function spaced(str,x,y,size,spacing,maxWidth){text(str,x,y,size,maxWidth,false,spacing)}
 function paw(x,y,scale=1){ctx.save();ctx.translate(x,y);ctx.scale(scale,scale);ctx.beginPath();ctx.moveTo(-20,10);ctx.bezierCurveTo(-42,25,-30,44,-12,35);ctx.bezierCurveTo(0,29,3,30,17,36);ctx.bezierCurveTo(38,44,42,23,21,8);ctx.bezierCurveTo(6,-15,-5,-15,-20,10);ctx.fill();[[-29,-14,-.4],[-11,-30,-.12],[12,-29,.15],[31,-12,.5]].forEach(([a,b,r])=>{ctx.beginPath();ctx.ellipse(a,b,10,16,r,0,Math.PI*2);ctx.fill()});ctx.restore()}
 function selectedOption(){return select?.selectedOptions[0]||root.querySelector('[data-preview-size]')?.selectedOptions[0]||root.querySelector('[data-fixed-variant]')}
 function render(){
  layoutMessage='';layoutKind='';
  const v=values(),option=selectedOption();
  const size=option?.dataset.size;
  const known=['600,400','700,400','900,600'].includes(size);
  const [physicalWidth,height]=(known?size:'600,400').split(',').map(Number);
  physicalHeight=height;
  const w=physicalWidth/(height/800),cx=w/2;
  canvas.width=w;canvas.height=800;
  root.querySelector('[data-preview-dimensions]').textContent=known?`${physicalWidth/10} × ${height/10} cm · width × depth`:'Size unavailable';
  ctx.fillStyle="#bf914c";ctx.fillRect(0,0,w,800);
  if(texture.complete&&texture.naturalWidth){ctx.fillStyle=ctx.createPattern(texture,"repeat");ctx.fillRect(0,0,w,800)}
  if(!known)flag('This size needs a manual artwork check. Please contact us before ordering.','blocking');
  const previewNote=!known?'':assetError?'The preview couldn’t load on this connection. You can still order — please check your wording carefully.':!fontsReady?'Loading your preview…':'';
  if(previewNote||!known){updateLayoutStatus(previewNote);return}
  ctx.fillStyle="#000";ctx.strokeStyle="#000";ctx.lineWidth=10;
  switch(Number(root.dataset.design)){
  case 1:text(v.house,cx,365,120,w-140,true);spaced(v.welcome,cx,500,47,13,w-240);break;
  case 2:text(v.number||"24",w*.246,410,310,w*.34,true);ctx.lineWidth=7;ctx.beginPath();ctx.moveTo(w*.467,245);ctx.lineTo(w*.467,560);ctx.stroke();const words=(v.street||"STREET NAME").split(/\s+/u);if(words.length>1){const mid=Math.ceil(words.length/2);text(words.slice(0,mid).join(" "),w*.709,360,85,w*.3875);text(words.slice(mid).join(" "),w*.709,460,85,w*.3875)}else text(words[0],w*.709,410,85,w*.3875);break;
  case 3:ctx.strokeRect(w*.06,70,w-w*.12,660);text(v.initial||"B",cx,350,400,w-380,true);spaced(v.family||"YOUR HOUSEHOLD",cx,615,51,11,w-260);break;
  case 4:text(v.names,cx,365,128,w-165,true);if(v.subline){spaced(v.subline,cx,510,47,10,590);ctx.lineWidth=7;ctx.beginPath();ctx.moveTo(cx-395,510);ctx.lineTo(cx-275,510);ctx.moveTo(cx+275,510);ctx.lineTo(cx+395,510);ctx.stroke()}break;
  case 5:paw(cx,135,1.5);spaced(v.heading,cx,292,52,10,w-200);text(v.dog,cx,450,205,w-180,true);spaced(v.pronoun,cx,620,47,9,w-210);break;
  case 6:spaced(v.topline,cx,240,55,9,w-200);text(v.greeting,cx,440,240,w-140,true);paw(cx,635,1.5);break;
  default:flag('This design needs a manual artwork check.','blocking');
  }
  canvas.setAttribute("aria-label",`${physicalWidth/10} by ${height/10} centimetre mat. Illustrative personalisation: ${Object.values(v).join(", ")}`);
  updateLayoutStatus('');
 }
 function nextLarger(){
  if(!select)return null;
  return [...select.options].slice(select.selectedIndex+1).find(o=>o.dataset.available==='true'&&['600,400','700,400','900,600'].includes(o.dataset.size))||null;
 }
 function updateLayoutStatus(previewNote){
  const status=root.querySelector('[data-layout-status]'),shown=previewNote||layoutMessage;
  status.textContent=shown;status.hidden=!shown;
  root.dataset.layoutValid=String(!layoutMessage);
  check?.setCustomValidity(layoutMessage);
  if(layoutMessage&&check)check.checked=false;
  if(alertBox){
   alertBox.hidden=!layoutMessage;alertText.textContent=layoutMessage;
   largerOption=layoutKind==='size'?nextLarger():null;
   if(tryLarger){tryLarger.hidden=!largerOption;if(largerOption)tryLarger.textContent=`Switch to ${largerOption.textContent.split('·')[0].trim()} · ${largerOption.dataset.price}`}
  }
  const selected=selectedOption(),unavailable=selected?.dataset.available!=='true';
  if(add&&!submitting){add.disabled=unavailable||!!layoutMessage;add.textContent=unavailable?add.dataset.unavailableLabel:add.dataset.readyLabel}
  if(sticky){const b=sticky.querySelector('[data-sticky-add]'),sp=sticky.querySelector('[data-sticky-price]');b.disabled=unavailable;if(add)b.textContent=unavailable?add.dataset.unavailableLabel:add.dataset.readyLabel;if(sp&&priceEl)sp.textContent=priceEl.textContent}
 }
 render();
 function validate(input,normalise=false){
  const value=input.value.trim().toUpperCase();
  if(normalise&&input.tagName==='INPUT')input.value=value;
  let message='';
  if(!value&&input.required)message='Please enter your wording.';
  else if(input.maxLength>0&&value.length>input.maxLength)message=`Please use no more than ${input.maxLength} characters.`;
  else if(input.dataset.key==='initial'&&!/^\p{L}$/u.test(value))message='Enter one letter.';
  input.setCustomValidity(message);
  const count=root.querySelector(`[data-count-for="${input.id}"]`);
  if(count)count.textContent=`${Array.from(input.value).length} / ${input.maxLength}`;
 }
 function wordingChanged(){if(check?.checked){check.checked=false;if(recheck)recheck.hidden=false}}
 check?.addEventListener('change',()=>{if(check.checked&&recheck)recheck.hidden=true});
 root.querySelectorAll('[data-key]').forEach(input=>{
  input.addEventListener('input',()=>{validate(input);wordingChanged();render()});
  input.addEventListener('change',()=>{validate(input,true);render()});
 });
 function sizeChanged(){
  const option=select?.selectedOptions[0];
  if(priceEl&&option?.dataset.price)priceEl.textContent=option.dataset.price;
  sizeButtons?.querySelectorAll('input[type=radio]').forEach(r=>{r.checked=r.value===select.value});
  render();
 }
 if(sizeButtons&&select){
  sizeButtons.hidden=false;if(sizeSelect)sizeSelect.hidden=true;
  sizeButtons.querySelectorAll('input[type=radio]').forEach(r=>r.addEventListener('change',()=>{if(r.checked){select.value=r.value;sizeChanged()}}));
 }
 select?.addEventListener('change',sizeChanged);
 root.querySelector('[data-preview-size]')?.addEventListener('change',render);
 tryLarger?.addEventListener('click',()=>{if(!largerOption)return;select.value=largerOption.value;sizeChanged();(sizeButtons||select).scrollIntoView({block:'center',behavior:'smooth'})});
 function finishSubmit(){
  render();
  if(layoutMessage){alertBox?.scrollIntoView({block:'center',behavior:'smooth'});return}
  submitting=true;if(add){add.disabled=true;add.textContent='Adding…'}
  form.submit();
 }
 form?.addEventListener('submit',event=>{
  if(submitting)return;
  root.querySelectorAll('[data-key]').forEach(input=>validate(input,true));
  const selected=selectedOption();
  if(event.target.dataset.orderingEnabled!=='true'||selected?.dataset.available!=='true'){event.preventDefault();return}
  event.preventDefault();
  render();
  if(layoutMessage){alertBox?.scrollIntoView({block:'center',behavior:'smooth'});return}
  if(!form.reportValidity())return;
  if(!fontsReady&&!assetError&&tdePrintAssets){
   if(add){add.disabled=true;add.textContent='Checking your wording…'}
   Promise.race([tdePrintAssets.catch(()=>{}),new Promise(r=>setTimeout(r,4000))]).then(finishSubmit);
   return;
  }
  finishSubmit();
 });
 window.addEventListener('pageshow',e=>{if(e.persisted){submitting=false;render()}});
 if(sticky&&add){
  sticky.hidden=false;document.body.classList.add('tde-has-sticky');
  let addVisible=true,typing=false;
  const sync=()=>sticky.classList.toggle('is-visible',!addVisible&&!typing);
  if('IntersectionObserver' in window)new IntersectionObserver(entries=>{addVisible=entries[0].isIntersecting;sync()}).observe(add);
  root.addEventListener('focusin',e=>{if(e.target.matches('input[type=text],input:not([type]),select')){typing=true;sync()}});
  root.addEventListener('focusout',()=>{typing=false;sync()});
  sticky.querySelector('[data-sticky-add]').addEventListener('click',()=>{
   if(add.disabled){(layoutMessage?alertBox:form)?.scrollIntoView({block:'center',behavior:'smooth'});return}
   add.click();
  });
 }
}
document.addEventListener('DOMContentLoaded',()=>initDoorstep());
document.addEventListener('shopify:section:load',event=>initDoorstep(event.target));
